import * as React from "react";
import { ButtonGroup } from "azure-devops-ui/ButtonGroup";
import { SplitButton } from "azure-devops-ui/SplitButton";
import { IMenuItem } from "azure-devops-ui/Menu";

import "./SplitButton.Example.css"

export default class SplitButtonExample extends React.Component {
    private menuItems: IMenuItem[] = [
        { id: "one", text: "Item 1" },
        { id: "two", text: "Item 2" },
        { id: "three", text: "Item 3" },
        { id: "four", text: "Item 4" },
        { id: "five", text: "Item 5" }
    ];

    public render(): JSX.Element {
        return (
            <div className="flex-column">
                <div>
                    <ButtonGroup className={"flex-wrap button-group"}>
                        <SplitButton
                            buttonProps={{
                                text: "Button",
                                onClick: () => {
                                    alert("Main button clicked");
                                }
                            }}
                            menuButtonProps={{
                                ariaLabel: "See options",
                                contextualMenuProps: {
                                    menuProps: {
                                        id: "1",
                                        items: this.menuItems
                                    }
                                }
                            }}
                        />
                        <SplitButton
                            primary={true}
                            buttonProps={{
                                text: "Primary button",
                                onClick: () => {
                                    alert("Main button clicked");
                                }
                            }}
                            menuButtonProps={{
                                ariaLabel: "See options",
                                contextualMenuProps: {
                                    menuProps: {
                                        id: "2",
                                        items: this.menuItems
                                    }
                                }
                            }}
                        />
                        <SplitButton
                            disabled={true}
                            buttonProps={{
                                text: "Disabled button",
                                onClick: () => {
                                    alert("Main button clicked");
                                }
                            }}
                            menuButtonProps={{
                                ariaLabel: "See options",
                                contextualMenuProps: {
                                    menuProps: {
                                        id: "4",
                                        items: this.menuItems
                                    }
                                }
                            }}
                        />
                        <SplitButton
                            buttonProps={{
                                text: "Icon button",
                                onClick: () => {
                                    alert("Main button clicked");
                                },
                                iconProps: {
                                    iconName: "Add"
                                }
                            }}
                            menuButtonProps={{
                                ariaLabel: "See options",
                                contextualMenuProps: {
                                    menuProps: {
                                        id: "5",
                                        items: this.menuItems
                                    }
                                }
                            }}
                        />
                    </ButtonGroup>
                </div>
            </div>
        );
    }
}
